import React, { useState, useCallback, useRef, useEffect, ChangeEvent } from 'react';
import { useMutation } from '@tanstack/react-query';
import { DeleteCategoryRequest } from '../../../types/api/categories';
import { CategoryResponse } from '../../../types/api/categories';
import { SubcategoryResponse } from '../../../types/api/catalogs';
import { deleteCategory } from '../../../services/categories';
import { deleteSubcategory } from '../../../services/catalogs';
import ModalSheet from '../../basic/ModalSheet';
import { Stack, Button, TextInput } from '@primer/react'
import { CategorySelect } from './select/CategorySelect';
import { SubcategorySelect } from './select/SubcategorySelect';

interface TransferAdsModalProps {
    category: CategoryResponse
    subcategory?: SubcategoryResponse
    isOpen: boolean;
    onDidDeleted: () => void;
    onClose: () => void;
}

export const TransferAdsModal: React.FC<TransferAdsModalProps> = ({ category, subcategory, isOpen, onDidDeleted, onClose }) => {

    const [selectedCategory, setSelectedCategory] = useState<CategoryResponse | undefined>(undefined);
    const [selectedSubcategory, setSelectedSubcategory] = useState<SubcategoryResponse | undefined>(undefined);
    const [isPending, setIsPending] = useState<boolean>(false)

    const { mutate: deleteCategoryRequest } = useMutation({
        mutationFn: ({ id, replaceBy }: {
            id: string,
            replaceBy: string
        }) => deleteCategory({ ids: [id], replaceBy: replaceBy }),
        onSuccess: (data) => {
            setIsPending(false);
            onDidDeleted()
            onClose()
        },
        onError: (_) => setIsPending(false)
    });

    const { mutate: deleteSubcategoryRequest } = useMutation({
        mutationFn: ({ id, replaceBy }: {
            id: string,
            replaceBy: string
        }) => deleteSubcategory({ ids: [id], replaceBy: replaceBy }),
        onSuccess: (data) => {
            setIsPending(false);
            onDidDeleted()
            onClose()
        },
        onError: (_) => setIsPending(false)
    });

    const startTransfer = () => {
        if (subcategory) {
            if (selectedCategory && selectedSubcategory) {
                setIsPending(true);
                deleteSubcategoryRequest({ id: subcategory.id, replaceBy: selectedSubcategory.id })
            }
            return
        }

        if (selectedCategory && selectedSubcategory) {
            setIsPending(true);
            deleteCategoryRequest({ id: category.id, replaceBy: selectedSubcategory.id })
        }
    };

    return (
        <ModalSheet
            isOpen={isOpen}
            onClose={onClose}
            title="Перенести объявления"
            size="middle"
            headerSize="regular"
        >
            {({ setTitle }) => (
                <Stack className='mt-[16px]'>
                    <CategorySelect
                        category={selectedCategory}
                        didCategorySelected={(category) => {
                            setSelectedCategory(category)
                            setSelectedSubcategory(undefined)
                        }}
                    />
                    <SubcategorySelect
                        parentCategory={selectedCategory}
                        subcategory={selectedSubcategory}
                        didSubcategorySelected={(subcategory) => setSelectedSubcategory(subcategory)}
                    />
                    <Stack direction="horizontal" gap='normal' justify='end'>
                        <div></div>
                        <Button
                            onClick={onClose}
                            size='small'
                            variant="default">
                            Отмена
                        </Button>
                        <Button
                            onClick={startTransfer}
                            size='small'
                            variant="danger"
                            loading={isPending}
                            disabled={isPending || selectedCategory === undefined || selectedSubcategory === undefined}>
                            Подтвердить удаление
                        </Button>
                    </Stack>
                </Stack>
            )}
        </ModalSheet>
    );
};